module.exports = __webpack_public_path__ + "img/man.713919ca.png";